import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { btnReset, v } from '../../styles/variables'

export const SSidebar = styled.div`
	min-width: ${({ isOpen }) => (!isOpen ? `92px` : v.sidebarWidth)};
	max-width: ${({ isOpen }) => (!isOpen ? `92px` : v.sidebarWidth)};
	background: ${({ theme }) => theme.bgf};
	height: 100%;
	padding: ${v.lgSpacing};
	position: relative;
	border-right: 1px solid ${({ theme }) => theme.bg3};
	overflow-y: auto;
	transition:
		min-width 0.2s ease,
		max-width 0.2s ease;

	&::-webkit-scrollbar {
		display: none;
	}
	-ms-overflow-style: none;
	scrollbar-width: none;

	@media (max-width: ${v.mobileMaxWidth}) {
		left: ${({ isOpen }) => (isOpen ? `0` : `-100px`)};
		margin-right: ${({ isOpen }) => (isOpen ? `0` : `-100px`)};
		position: absolute;
		z-index: 2;
	}
`

export const SSidebarButton = styled.button`
	${btnReset};
	position: absolute;
	top: 83px;
	left: ${({ isOpen }) => (isOpen ? `240px` : `80px`)};
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background: ${({ theme }) => theme.bg2};
	border: 1px solid ${({ theme }) => theme.bg3};
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 5;
	transform: ${({ isOpen }) => (!isOpen ? `rotate(180deg)` : `initial`)};
	transition: all 0.2s ease;

	&:hover {
		background: ${({ theme }) => theme.bg3};
	}

	@media (max-width: ${v.mobileMaxWidth}) {
		left: ${({ isOpen }) => (isOpen ? `240px` : `20px`)};
	}
`

export const SLogo = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	img {
		max-width: ${({ isOpen }) => (isOpen ? `220px` : `48px`)};
		height: auto;
		transition: max-width 0.2s ease;
	}
	margin-bottom: ${({ isOpen }) => (isOpen ? `8px` : v.lgSpacing)};
`

export const SSearch = styled.div`
	background: ${({ theme }) => theme.bg};
	border: 1px solid ${({ theme }) => theme.bg3};
	border-radius: ${v.borderRadius};
	transition: border-color 0.15s ease;

	&:focus-within {
		border-color: ${({ theme }) => theme.primary};
	}

	input {
		padding: 0 ${v.smSpacing};
		font-family: inherit;
		font-size: 14px;
		width: 100%;
		outline: none;
		border: none;
		color: inherit;
		background: transparent;
	}
	display: flex;
`

export const SSearchIcon = styled.button`
	${btnReset};
	padding: calc(${v.mdSpacing} - 2px) ${v.mdSpacing};
	display: flex;
	cursor: pointer;
	color: ${({ theme }) => theme.bgText};
	svg {
		font-size: 18px;
	}
`

export const SDivider = styled.div`
	height: 1px;
	width: 100%;
	background: ${({ theme }) => theme.bg3};
	margin: ${v.lgSpacing} 0;
`

export const SDropDownDivider = styled.div`
	height: 1px;
	width: 15%;
	background: ${({ theme }) => theme.bg3};
	margin: 0 ${v.mdSpacing};
`

export const SLinkContainer = styled.div`
	background: ${({ theme, isActive }) => (!isActive ? `transparent` : theme.bg2)};
	border-radius: ${v.borderRadius};
	margin: 4px 0;
	transition: background 0.15s ease;

	:hover {
		background: ${({ theme }) => theme.bg2};
	}
`

export const SLinkDropDownContainer = styled.div`
	background: ${({ theme, isActive }) => (!isActive ? `transparent` : theme.bg2)};
	border-radius: ${v.borderRadius};
	margin: 4px 0;
	transition: background 0.15s ease;

	:hover {
		background: ${({ theme }) => theme.bg2};
	}
`

export const SLink = styled(Link)`
	display: flex;
	align-items: center;
	max-height: 46px;
	text-decoration: none;
	color: inherit;
	font-size: 14.5px;
	font-weight: 500;
	padding: calc(${v.smSpacing} - 1px) 0;
	border-radius: ${v.borderRadius};
	transition: color 0.15s ease;

	&:hover {
		color: ${({ theme }) => theme.text};
	}
`

export const SLinkIcon = styled.div`
	padding: ${v.smSpacing} ${v.mdSpacing};
	display: flex;
	color: ${({ theme }) => theme.bgText};
	svg {
		font-size: 18px;
	}
`

export const SLinkLogo = styled.img`
	height: 36px;
	display: flex;
	padding: ${v.smSpacing} 0;
	border-radius: 100%;
`

export const SLinkLabel = styled.span`
	display: block;
	flex: 1;
	margin-left: ${v.smSpacing};
`

export const SLinkNotification = styled.div`
	font-size: 12px;
	padding: calc(${v.smSpacing} / 2) ${v.smSpacing};
	border-radius: calc(${v.borderRadius} / 2);
	background: ${({ theme }) => theme.bgAlpha};
	color: ${({ theme }) => theme.text};
	margin-right: ${v.mdSpacing};
`
export const SDropdownWrapper = styled.div`
	overflow: hidden;
	max-height: ${({ isOpen }) => (isOpen ? '1000px' : '0')};
	opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
	transition:
		max-height 0.35s ease,
		opacity 0.25s ease;
`

export const SChevron = styled.div`
	display: flex;
	align-items: center;
	transition: transform 0.3s ease;
	transform: ${({ isOpen }) => (isOpen ? 'rotate(0deg)' : 'rotate(-90deg)')};
`
